import myApplications from "./myApplications";

export default myApplications;
